import React from 'react'
import Card from './Card'

export default function Section(props) {
    const data = {
        // Fp: ["Local shop"],
        Ux: [
            "Local shop",
            "Dev"
        ],
        Ui: ["Dna"],
        Dev: [
            "Learner",
            "Amazon-clone",
            "Ecom"
        ],
        Daily: [
            "Daily ui",
            "Logo",
            "Digital painting",
            "Photo manipulation",
            "Illustration",
            "Infographics",
            "Isometric",
            "Brand",
            "Fontography",
            "Icon",
            "Gif",
            "Smudge painting"
        ]
    }

    const fun =() => {
        if(props.title === "Case studies"){
            const detail = data.Fp.map(e =>  <div key={e} className="col-sm-6 col-lg-4 pt-4"><Card req_link={props.title} name={e}/></div>)
             return detail
         }
        else if(props.title === "Ux design"){
            const detail = data.Ux.map(e =>  <div key={e} className="col-sm-6 col-lg-4 pt-4"><Card req_link={props.title}  name={e}/></div>)
            return detail
        }
        else if(props.title === "Ui design"){
            const detail = data.Ui.map(e =>  <div key={e} className="col-sm-6 col-lg-4 pt-4"><Card req_link={props.title}  name={e}/></div>)
            return detail
        }
        else if(props.title === "Development"){
            const detail = data.Dev.map(e =>  <div key={e} className="col-sm-6 col-lg-4 pt-4"><Card req_link={props.title}  name={e}/></div>)
            return detail
        }
        else if(props.title === "Graphic design"){
            const detail = data.Daily.map(e =>  <div key={e} className="col-sm-6 col-lg-4 pt-4"><Card req_link={props.title}  name={e}/></div>)
            return detail
        }
    }
    return (
        <div className="px-3 px-sm-5 pt-5">
            <p className="text-muted" style={{letterSpacing: '2px'}}>{props['subtitle']}</p>
            <h2 className="fopri">{props['title']}</h2>
            <div className="row">
                {fun()}
            </div>
        </div>
        
    )
}
